import { store } from "app/store";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import i18n from "./i18n";

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <Provider store={store}>
          <I18nextProvider i18n={i18n}>
            <Helmet>
              {/* <!-- pre-license-user.automation.omron.com に対する OneTrust Cookie 同意通知の始点 --> */}
              <script type="text/javascript" src="https://cdn-au.onetrust.com/consent/01924c39-4328-76fa-bcaf-0f932c275aa4/OtAutoBlock.js" ></script>
              <script src="https://cdn-au.onetrust.com/scripttemplates/otSDKStub.js"  type="text/javascript" charSet="UTF-8" data-domain-script="01924c39-4328-76fa-bcaf-0f932c275aa4" ></script>
              <script type="text/javascript">
              {'function OptanonWrapper() { }'}
              </script>
              {/* <!-- pre-license-user.automation.omron.com に対する OneTrust Cookie 同意通知の終点 --> */}
            </Helmet>
            <App />
          </I18nextProvider>
        </Provider>
      </HelmetProvider>
    </React.StrictMode>
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
